import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";

@Component({
  selector: "er-back-button",
  imports: [MatIconModule, RouterModule],
  standalone: true,
  templateUrl: "./back-button.component.html",
  styleUrl: "./back-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {}
